import { render } from "./PropertyCategoryEditing.vue?vue&type=template&id=42eb8326&ts=true"
import script from "./PropertyCategoryEditing.vue?vue&type=script&lang=ts"
export * from "./PropertyCategoryEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__